import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCT_DETAIL_REQUEST,
  FETCH_PRODUCT_DETAIL_SUCCESS,
  FETCH_PRODUCT_DETAIL_FAILURE,
  ADD_PRODUCT_REQUEST,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAILURE,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  SEARCH_PRODUCTS_REQUEST,
  SEARCH_PRODUCTS_SUCCESS,
  SEARCH_PRODUCTS_FAILURE,
  FETCH_ACTIVE_PRODUCTS_REQUEST,
  FETCH_ACTIVE_PRODUCTS_SUCCESS,
  FETCH_ACTIVE_PRODUCTS_FAILURE,
  TOGGLE_PRODUCT_ACTIVE_REQUEST,
  TOGGLE_PRODUCT_ACTIVE_SUCCESS,
  TOGGLE_PRODUCT_ACTIVE_FAILURE,
  FETCH_PRODUCT_STATS_REQUEST,
  FETCH_PRODUCT_STATS_SUCCESS,
  FETCH_PRODUCT_STATS_FAILURE
} from '../types/productTypes';

const initialState = {
  items: [],
  currentProduct: null,
  activeProducts: [],
  stats: null,
  loading: false,
  error: null,
  total: 0,
  pagination: {
    currentPage: 1,
    perPage: 15,
    totalPages: 0
  }
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS_REQUEST:
    case FETCH_PRODUCT_DETAIL_REQUEST:
    case ADD_PRODUCT_REQUEST:
    case UPDATE_PRODUCT_REQUEST:
    case DELETE_PRODUCT_REQUEST:
    case SEARCH_PRODUCTS_REQUEST:
    case FETCH_ACTIVE_PRODUCTS_REQUEST:
    case TOGGLE_PRODUCT_ACTIVE_REQUEST:
    case FETCH_PRODUCT_STATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items || [],
        total: action.payload.total || 0,
        pagination: {
          ...state.pagination,
          currentPage: action.payload.current_page || 1,
          perPage: action.payload.per_page || 15,
          totalPages: action.payload.last_page || 0
        }
      };

    case FETCH_PRODUCT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentProduct: action.payload
      };

    case ADD_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: [action.payload, ...state.items],
        total: state.total + 1
      };

    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(item =>
          item.product_id === action.payload.product_id ? action.payload : item
        ),
        currentProduct: state.currentProduct?.product_id === action.payload.product_id 
          ? action.payload 
          : state.currentProduct
      };

    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(item => item.product_id !== action.payload),
        total: state.total - 1
      };

    case SEARCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.items || [],
        total: action.payload.total || 0,
        pagination: {
          ...state.pagination,
          currentPage: action.payload.current_page || 1,
          perPage: action.payload.per_page || 15,
          totalPages: action.payload.last_page || 0
        }
      };

    case FETCH_ACTIVE_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        activeProducts: action.payload
      };

    case TOGGLE_PRODUCT_ACTIVE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.map(item =>
          item.product_id === action.payload.product_id ? action.payload : item
        ),
        currentProduct: state.currentProduct?.product_id === action.payload.product_id 
          ? action.payload 
          : state.currentProduct
      };

    case FETCH_PRODUCT_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload
      };

    case FETCH_PRODUCTS_FAILURE:
    case FETCH_PRODUCT_DETAIL_FAILURE:
    case ADD_PRODUCT_FAILURE:
    case UPDATE_PRODUCT_FAILURE:
    case DELETE_PRODUCT_FAILURE:
    case SEARCH_PRODUCTS_FAILURE:
    case FETCH_ACTIVE_PRODUCTS_FAILURE:
    case TOGGLE_PRODUCT_ACTIVE_FAILURE:
    case FETCH_PRODUCT_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default productReducer;
